import Storage from '@/class/Storage';

export default new Storage(localStorage);
